import React, { Component } from 'react';
import history from '../../services/history';
import queryStringParams from '../../services/queryStringParams';
import _ from 'lodash';

export default (qsKeys) => (WrappedComponent) => {
  class EnhancedComponent extends Component {
    constructor(props) {
      super(props);
      this.state = queryStringParams.get(qsKeys);
    }

    setQueryStringParams = (params, replace) => {
      queryStringParams.set(params, replace);
      return params;
    };

    componentDidMount() {
      this.unlisten = history.listen(() => {
        const qsObj = queryStringParams.get(qsKeys);

        if (!_.isEqual(qsObj, _.omitBy(this.state, _.isNil))) {
          // Set state with qs params and make sure missing qs params are set to 'undefined'
          const allQsKeysObj = qsKeys.reduce((obj, key) => {
            obj[key] = undefined;
            return obj;
          }, {});
          this.setState(Object.assign({}, allQsKeysObj, qsObj));
        }
      });
    }

    componentWillUnmount() {
      this.unlisten();
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          qs={{ set: this.setQueryStringParams }}
        />
      );
    }
  }

  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  EnhancedComponent.displayName = `WithQueryStringProps(${wrappedComponentName})`;

  return EnhancedComponent;
};



// WEBPACK FOOTER //
// ./src/components/withQueryStringProps/withQueryStringProps.js